import { jsPlumbConnection } from './utils/locaction-calculator-interface';
import { jsPlumb } from 'jsplumb';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

const ancTypes = {
  // action_to_menu: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.5, -1, 0, 18, 0]],
  // action_to_default: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.49, -1, 0, 0, 0]],
  // action_to_action: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.5, -1, 0, 8, 0]],
  // action_to_menu_existing: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.5, -1, 0, 30, 0]],
  // action_to_action_existing: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.5, -1, 0, 18, 0]],
  // action_to_default_existing: [[0.2, 1.01, 0, 1, 0, -8], [0, 0.5, -1, 0, 12, 0]],
  //
  // default_to_menu: [[0.2, 1.01, 0, 1, 0, -3], [0, 0.5, -1, 0, 18, 0]],
  // default_to_action: [[0.2, 1.01, 0, 1, 0, -3], [0, 0.5, -1, 0, 8, 0]],
  // default_to_menu_existing: [[0.2, 1.01, 0, 1, 0, -3], [0, 0.5, -1, 0, 30, 0]],
  // default_to_action_existing: [[0.2, 1.01, 0, 1, 0, -3], [0, 0.5, -1, 0, 18, 0]],
  // default_to_default_existing: [[0.2, 1.01, 0, 1, 0, -3], [0, 0.5, -1, 0, 12, 0]],

  input: [
    [0.2, 1, 0, 1, 23, -50],
    [0, 0.49, -1, 0, 15, 0],
  ],
  start_to_input: [
    [0.2, 1, 0, 1, 23, 0],
    [0, 0.49, -1, 0, 15, 0],
  ],
  start: [
    [0.2, 1, 0, 1, 23, 0],
    [0, 0.49, -1, 0, 10, 0],
  ],
  default: [
    [0.2, 1, 0, 1, 23, -50],
    [0, 0.49, -1, 0, 10, 0],
  ],
};

export class JsPlumbService {
  private jsPlumbInstance: any;
  private jsPlumbConnections: jsPlumbConnection[] = [];

  constructor(area: HTMLDivElement, private sanitizer: DomSanitizer) {
    this.jsPlumbInstance = jsPlumb.getInstance();
    this.jsPlumbInstance.setContainer(area);
  }

  resetConnections() {
    this.jsPlumbInstance.deleteEveryEndpoint();
    this.jsPlumbConnections = [];
  }

  public addJsPlumbArrows() {
    this.jsPlumbInstance.batch(() => {
      this.jsPlumbConnections.forEach((connection: any) => {
        this.jsPlumbInstance.connect(connection);
      });
    });
  }

  public addJsPlumbClick() {
    this.jsPlumbInstance.bind('click', (conn) => {
      if (conn.canvas.classList[1] === 'connectionLineClicked' && conn.type !== 'Label') {
        conn.canvas.classList.replace('connectionLineClicked', 'connectionLine');
        conn.canvas.classList.value = conn.canvas.classList[0] + ' connectionLine';
      } else if (conn.type !== 'Label') {
        conn.canvas.classList.replace('connectionLine', 'connectionLineClicked');
        conn.canvas.classList.value = conn.canvas.classList[0] + ' connectionLineClicked';
      }
    });

    this.jsPlumbInstance.bind('mouseover', (conn, mouseEvent) => {
      const toolTipText = mouseEvent.srcElement.innerHTML;
      if (toolTipText === '' || toolTipText.length < 16) {
        return;
      }

      const mouseoverLabel = conn.getOverlay('mouseoverLabel');
      if (mouseoverLabel) {
        return;
      }

      this.addTooltipToJsPlumbLabel(conn, toolTipText, false);
    });

    this.jsPlumbInstance.bind('mouseout', (conn) => {
      const mouseoverLabel = conn.getOverlay('mouseoverLabel');
      if (mouseoverLabel) {
        conn.removeOverlay('mouseoverLabel');
      }
    });
  }

  private addTooltipToJsPlumbLabel(conn, toolTipText: string, enabled: boolean) {
    if (enabled) {
      const top = conn.canvas.previousSibling.style.top.replace('px', '') - 30;
      conn.addOverlay([
        'Label',
        { label: toolTipText, location: -120, id: 'mouseoverLabel', cssClass: 'JsPlumbTooltip' },
      ]);
      let jsPlumbTooltipElement: HTMLDivElement = document.getElementsByClassName(
          'JsPlumbTooltip'
      )[0] as HTMLDivElement;
      jsPlumbTooltipElement.style.top = `${top}px`;
    }
  }

  private setLabelCssClass(label) {
    return label === 'success' || label === 'error' || label === 'true' || label === 'false'
      ? `LblText ${label}-lbl`
      : 'LblText';
  }

  /**
   * Applies default styles to connections and labels  that were executed on the preview component
   * @param source the nodeId that the connection originates from
   * @param target the nodeId that is being executed
   */
  public setExecutedStyles(source: string, target: string) {
    for (const endpoint of this.jsPlumbInstance.getEndpoints(source)) {
      if (endpoint.connections[0].sourceId === source && endpoint.connections[0].targetId === target) {
        const connection = endpoint.connections[0];
        const targetType = connection.target.getAttribute('nodeType');
        const overlayId = this.getLabelOverlayId(connection.getOverlays());
        const label = connection.getOverlay(overlayId).labelText;
        const anchorType = (source === 'start' && targetType === 'askInput') ? 'input' : 'default';
        const newConnection = this.getJsPlumbConnection(source, target, label, anchorType);
        this.jsPlumbInstance.deleteConnection(connection);
        this.jsPlumbInstance.connect(newConnection);
      }
    }
  }

  /**
   * set the unexecuted css styles on connections and labels to the flow in the preview
   */
  public setUnexecutedStyles() {
    const connections = this.jsPlumbInstance.getAllConnections();
    connections.forEach((connection) => {
        connection.getOverlay(this.getLabelOverlayId(connection.getOverlays())).addClass('notExecuted');
        connection.canvas._jsPlumb._jsPlumb.paintStyle.stroke = '#8893a5';
        connection.repaint();
    });
  }

  /**
   * gets the ID of the label overlay
   * @param obj overlay object already set on the connection, contains arrow and label overlays
   */
  getLabelOverlayId(obj: Object): string {
    for (const objKey in obj) {
      if (obj[objKey]['type'] === 'Label') {
        return objKey;
      }
    }
  }

  public toJsPlumb(source: string, target: string, label: string, anchorType: string) {
    const new_label = this.sanitizer.sanitize(SecurityContext.HTML, label);
    const connection = this.getJsPlumbConnection(source, target, new_label, anchorType);
    this.jsPlumbConnections.push(connection);
  }

  public getJsPlumbConnection(source: string, target: string, label: string, anchorType: string): jsPlumbConnection {
    const endpoint = [
      'Rectangle',
      {
        cssClass: `myEndpoint ${source}-anchor`,
        width: 1,
        height: 1,
      },
    ];

    let anchors = ancTypes.default;
    if (source === 'start' && anchorType === 'input') {
      anchors = ancTypes['start_to_input'];
    } else if (source === 'start') {
      anchors = ancTypes['start'];
    }

    const overlays = [
      [
        'Arrow',
        {
          location: 1,
          width: 8,
          length: 8,
          dashstyle: 'dash',
        },
      ],
      [
        'Label',
        {
          label: label,
          location: -120,
          id: 'lbl' + label,
          cssClass: this.setLabelCssClass(label),
        },
      ],
    ];

    const goTo = target.match(new RegExp('step', 'g'));

    const paintStyle =
      goTo && goTo.length === 2
        ? { stroke: '#8591a6', strokeWidth: 2, dashstyle: '2 2 2' }
        : { stroke: '#233659', strokeWidth: 2 };

    return {
      source: source,
      target: target,
      anchor: anchors,
      cssClass: 'connectionLine',
      endpoint: endpoint,
      connector: ['Flowchart'],
      overlays: overlays,
      paintStyle: paintStyle,
    };
  }

  public JsPlumbLoop(source) {
    const label = 'loop';
    // const anchors = ['Right'];
    const anchors = [0.85, 1, 0, 1];
    const endpoint = [
      'Rectangle',
      {
        cssClass: 'myEndpoint loop',
        width: 32,
        height: 32,
      },
    ];
    const paintStyle = {
      stroke: 'transparent',
      strokeWidth: 0,
    };
    const overlays = [
      [
        'Arrow',
        {
          location: 0,
        },
      ],
      [
        'Label',
        {
          label: '',
          location: 50,
          id: 'lbl' + label,
          cssClass: this.setLabelCssClass(label),
        },
      ],
    ];
    const connection: jsPlumbConnection = {
      source: source,
      target: source,
      anchor: anchors,
      endpoint: endpoint,
      paintStyle: paintStyle,
      overlays: overlays,
    };

    this.jsPlumbConnections.push(connection);
  }

  public redrawArrows() {
    this.jsPlumbInstance.deleteEveryEndpoint();
    this.jsPlumbInstance.batch(() => {
      this.jsPlumbConnections.forEach((connection: any) => {
        this.jsPlumbInstance.connect(connection);
      });
    });
  }
}
